module.exports = __webpack_public_path__ + "static/work48-31bd14b96603a8577b865b833fb15b9e.jpg";